var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"cozeMain",staticClass:"cozeMain"},[_c('CozeChat',{attrs:{"agentId":"7558105919985958966","cozeWidth":_vm.cozeWidth,"title":"作业自动诊断助手"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }